import { lazy } from 'react'

export const AppRenderingErrorFallbackPage = lazy(() => import('./page'))
